var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},_vm._l((_vm.data),function(item,index){return _c('ListItem',{key:index,attrs:{"label":item.label,"value":item.value,"condition":item.condition}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }